module.exports = __webpack_public_path__ + "img/7.2cb04f3a.png";